module.exports = __webpack_public_path__ + "static/img/file4.f350d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/file4.png
// module id = dfrM
// module chunks = 1